module.exports = __webpack_public_path__ + "static/media/industrial-manufacturing.97a73b12.svg";